interface Props {
  name?: string;
}

export default function TypingIndicator({ name }: Props) {
  return (
    <div className="flex items-center gap-2 text-xs text-ink-500 dark:text-ink-300" aria-live="polite">
      <span className="inline-flex items-center gap-1 rounded-full bg-ink-100 px-2 py-1 dark:bg-ink-800" aria-hidden="true">
        <span className="h-1.5 w-1.5 animate-bounce-dot rounded-full bg-ink-400" style={{ animationDelay: '0ms' }} />
        <span className="h-1.5 w-1.5 animate-bounce-dot rounded-full bg-ink-400" style={{ animationDelay: '150ms' }} />
        <span className="h-1.5 w-1.5 animate-bounce-dot rounded-full bg-ink-400" style={{ animationDelay: '300ms' }} />
      </span>
      <span>{name ? `${name} is typing…` : 'Typing…'}</span>
    </div>
  );
}
